import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { START_ORDER } from '../modules/constants';
import { track } from '../modules/tracking';

const COMPONENT_CLASS_NAMES = 'bottomButton hide';
const LINK_CLASS_NAMES = 'main cta';

/**
 * Button that appears at the bottom of the page allowing someone to make an order.
 *
 * @function
 * @constructor
 */
function BottomButton({ market }) {
    const button = useRef(null);

    const orderLink =
        market === 'UK'
            ? 'https://www.nandos.co.uk/order/search'
            : 'https://www.nandos.ie/order/search';

    useEffect(() => {
        const topBanner = document.querySelector('.topBanner');

        if (!('IntersectionObserver' in window) || !topBanner) {
            return null;
        }

        function observe(entries) {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    button.current.classList.add('hide');
                } else {
                    button.current.classList.remove('hide');
                }
            });
        }

        const options = {
            rootMargin: '0px',
            threshold: [0]
        };

        const observer = new IntersectionObserver(observe, options);

        observer.observe(topBanner);

        return () => {
            observer.unobserve(topBanner);
        };
    }, []);

    return (
        <div ref={button} className={COMPONENT_CLASS_NAMES}>
            <a
                onClick={track(
                    'BottomButton: Click: Open: Start your order CTA'
                )}
                href={orderLink}
                className={LINK_CLASS_NAMES}
                data-ga-dmt='browsing menu - footer pop up'
                data-ga-location='footer_popup_bm'
                data-ga-display='pop up'
                data-ga-dmt-cta='start order footer'
                data-ga-action='clickable'
            >
                {START_ORDER}
            </a>
        </div>
    );
}

BottomButton.propTypes = {
    market: PropTypes.string
};

export { BottomButton };
